var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import ReactLoading from 'react-loading';
var Text = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var bold = _a.bold, light = _a.light;
    if (bold)
        return 'bold';
    if (light)
        return 'lighter';
    return 'normal';
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryTextColor;
});
export default {
    Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 0 auto;\n    background-color: ", ";\n    width: 100%;\n    height: 100%;\n    position: relative;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 0 auto;\n    background-color: ", ";\n    width: 100%;\n    height: 100%;\n    position: relative;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.backgroundColor;
    }),
    Loading: styled(ReactLoading)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    background-color: ", ";\n  "], ["\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.backgroundColor;
    }),
    SafeArea: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex: 1;\n    background-color: ", ";\n  "], ["\n    flex: 1;\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.backgroundColor;
    }),
    Text: Text,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
